// v8: the top-center pill strip (CrashMultiplierHistory) is GONE — crash
// past rounds now render inside ShowRaceResults (right side, same placement
// and interaction feel as every other game's recent results). What lives on
// here is the provably-fair story: the round modal + the pure round-selection
// helpers that feed it.
export { CrashRoundModal } from './CrashRoundModal'
export {
  deriveCrashPastResults,
  formatTimeAgo,
  getMultiplierTier,
  hasRoundFairness,
  resolveModalRace,
  selectRoundFairness
} from './crashRoundFairness'
export type { CrashPastResult, RoundFairnessGame } from './crashRoundFairness'
